import React from 'react'
import MaterialTable from '@material-table/core'
import { Colors } from '@auteco/theme';
import { format } from 'date-fns'

const FinalValuesTable = ({ consolidadoMaterialInfo, leadTime }) => {
  const formatUnixToMonthYear = (unix) => {
    try {
      return format(new Date((unix + 86000) * 1000), 'MMM yy')
    }catch(e){
      return ''
    }
  }
  
    const data = consolidadoMaterialInfo.map((item, index) => ({
      index: index + 1,
      mes: ( item.mes_unix && item.mes_unix > 0 )? formatUnixToMonthYear(item.mes_unix) : '',
      final: item.final || '0',
      presupuesto_unidades: item.presupuesto_unidades || '0',

    }))
  
    // Helper function to transform data
    const transformData = (data, rows) => {
      const columns = [
        { title: ' ', field: 'title',   },
        ...data.map((item, index) => ({ title: item.mes, field: item.mes, sorting: false,  headerStyle: {
          backgroundColor: Colors.BLUE,
          color: index > leadTime ? '#f1f1f1' : "#00faff",
          fontSize: '12px',
          fontWeight: 700,
        },   cellStyle: { width: '80px', minWidth: '80px', height: '50px'  } })),
      ]
  
      const transformedData = rows.map((row) => {
        const rowData = { title: row.title }
        data.forEach((item) => {
          rowData[item.mes] = item[row.field] || ''
        })
        return rowData
      })
  
      return { columns, transformedData }
    }
  
    // Data for the second table
    const secondTableData = data.filter(  
      (item) => item.index >= 13
    )
    console.log('data', data)
    console.log('DataFinal', secondTableData)
    const rowsForSecondTable = [{ title: 'Presupuesto', field: 'presupuesto_unidades' }]
  
    const secondTable = transformData(secondTableData, rowsForSecondTable)
  
    return (
      <>
        <MaterialTable
          title="Baseline"
          data={secondTable.transformedData}
          columns={secondTable.columns}
          options={{
            toolbar: false,
            paging: false, // Desactiva la paginación
            headerStyle: {
              backgroundColor: Colors.BLUE,
              color: '#f1f1f1',
              fontSize: '12px',
              fontWeight: 100,
            },
            rowStyle: (rowData, index) => ({
              backgroundColor: index % 2 === 0 ? 'white' : Colors.GRAY_BACKGROUND,
              padding: '5px', fontSize: '12px',
            }),
          }}
        />
      </>
    )
  }
  
export { FinalValuesTable }